export default function PlayButton({ color = 'white', className = '' }) {
	return (
		<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				stroke="none"
				d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32ZM32 4C16.5361 4 4 16.5361 4 32C4 47.4639 16.5361 60 32 60C47.4639 60 60 47.4639 60 32C60 16.5361 47.4639 4 32 4Z"
			/>
			<path
				stroke="none"
				d="M27.5547 21.168C27.2478 20.9634 26.8533 20.9443 26.5281 21.1183C26.203 21.2923 26 21.6312 26 22V42C26 42.3688 26.203 42.7077 26.5281 42.8817C26.8533 43.0557 27.2478 43.0366 27.5547 42.8321L42.5547 32.8321C42.8329 32.6466 43 32.3344 43 32C43 31.6656 42.8329 31.3534 42.5547 31.168L27.5547 21.168Z"
			/>
		</svg>
	)
}
